import { Theme } from '@mui/material';
import { WbGridCol, WbGridRow, WbIcon, WbLink, WbText } from '@workbench/react';
import { makeStyles } from 'tss-react/mui';
import LoginButton from '../../common/components/input/LoginButton';
import { useTranslation } from '../../common/i18n/useTranslation';
import UmasOverlay from '../umas/UmasOverlay';
import BeamButton from '../../common/components/input/BeamButton';
import { REGISTRATION_GUIDELINES_DE, REGISTRATION_GUIDELINES_EN } from '../../utils/constants';
import { useRestOperations } from '../../common/rest/restOperations';
import { ApiUrls } from '../../../api/api/apiUrls';
import { PublicFiles } from '../../utils/enums';
import { useTranslationContext } from '../../common/i18n/TranslationProvider';
import { useClientCompanyRegistrationContext } from '../client/companyRegistration/context/ClientCompanyRegistrationContext';
import { SupportedLanguages } from '../../common/i18n/SupportedLanguages';

const useStyles = makeStyles()((theme: Theme) => ({
    spacing: {
        marginBottom: theme.spacing(4),
    },
    link: {
        marginLeft: theme.spacing(3),
    },
}));

function RegistrationInit() {
    const { classes } = useStyles();
    const translate = useTranslation();
    const { doDownloadFile } = useRestOperations();
    const { langState } = useTranslationContext();
    const { isUmasRegistrationModalOpen, setIsUmasRegistrationModalOpen } = useClientCompanyRegistrationContext();

    const onSaveFile = async () => {
        await doDownloadFile(
            ApiUrls.publicApi.getPublicFile(PublicFiles.REGISTRATION_GUIDELINES, langState.toUpperCase()),
            langState === SupportedLanguages.de ? REGISTRATION_GUIDELINES_DE : REGISTRATION_GUIDELINES_EN
        );
    };

    return (
        <>
            <WbText size="m">{translate('want_to_register')}</WbText>
            <WbText size="m" className={classes.spacing}>
                {translate('prompt_registration')}
            </WbText>
            <WbGridRow className={classes.spacing}>
                <WbGridCol mq1={10}>
                    <BeamButton variant="primary" size="s" onClick={() => setIsUmasRegistrationModalOpen(true)}>
                        <WbIcon name="bds/link/24" />
                        {translate('registration')}
                    </BeamButton>
                    <WbLink href="#" variant="standalone" theme="dark" className={classes.link} onClick={onSaveFile}>
                        <WbIcon name="bds/document/24" />
                        {translate('reg_guideLines')}
                    </WbLink>
                </WbGridCol>
            </WbGridRow>
            <WbText size="m">{translate('registration_status_question')}</WbText>
            <WbText size="m" className={classes.spacing}>
                {translate('prompt_login')}
            </WbText>
            <LoginButton className={classes.spacing} variant="primary" size="s" />
            {isUmasRegistrationModalOpen && <UmasOverlay />}
        </>
    );
}

export default RegistrationInit;
